import moment from "moment";
import React, { use, useState } from "react";
import { FiCheckSquare } from "react-icons/fi";
import { useAppDispatch, useAppSelector } from "src/Redux/hooks";
import { convertTo12HourFormat } from "src/Utils/Functions";
import { IoMdTime } from "react-icons/io";
import { MdOutlineDateRange } from "react-icons/md";
import { setPeople } from "src/Redux/appSlice";

const Summary = () => {
  const dispatch = useAppDispatch();
  const classes = useAppSelector((state) => state.app.class);
  const people = useAppSelector((state) => state.app.people);
  const maxPeople = useAppSelector((state) => state.app.maxPeople);
  const date = useAppSelector((state) => state.app.date);
  const time = useAppSelector((state) => state.app.time);
  const [count, setCount] = useState<number>(people);
  return (
    <div className="p-6 mx-auto border rounded-lg shado-md bg-white mx-3 my-3">
      <h2 className="text-lg font-semibold mb-4">Summary</h2>

      <div className="flex justify-between items-center mb-4 border-2 rounded-md     p-2">
        <div>
          <p className="font-medium font-bold	">
            {classes?.name +
              " " +
              `INR ${classes?.price}` +
              " x " +
              count +
              " person"}
          </p>
          <p className="flex items-center gap-1 text-sm">
            <MdOutlineDateRange />
            {moment(date).format("MMMM DD, YYYY")}
          </p>
          <p className="flex items-center gap-1 text-sm">
            <IoMdTime />
            {convertTo12HourFormat(time || "")}
          </p>
        </div>
        <div>
          <div className="flex gap-2">
            <button
              onClick={() => {
                if (count >= maxPeople) return;
                dispatch(setPeople(count + 1));
                setCount(count + 1);
              }}
            >
              +
            </button>
            <input
              value={count}
              max={maxPeople}
              min={1}
              type="text"
              style={{
                width: "29px",
                border: "1px solid black",
                padding: "0.1rem .5rem",
                borderRadius: "6px",
              }}
            />
            <button
              onClick={() => {
                if (count <= 1) return;
                dispatch(setPeople(count - 2));
                setCount(count - 1);
              }}
            >
              -
            </button>
          </div>
          <p className="font-medium mt-2">{`INR ${
            (classes?.price ?? 0) * count
          }`}</p>
        </div>
      </div>

      <div className="flex justify-between items-center mt-4">
        <p className="font-medium text-lg">Total Amount:</p>
        <p className="font-semibold text-lg">{`INR ${
          (classes?.price ?? 0) * count
        }`}</p>
      </div>
    </div>
  );
};

export default Summary;
